import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search-red",
  "use": "icon-search-red-usage",
  "viewBox": "0 0 60 60",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 60 60\" id=\"icon-search-red\">\n  <g id=\"icon-search-red_Group_4990\" data-name=\"Group 4990\" transform=\"translate(-1480)\">\n    <rect id=\"icon-search-red_Rectangle_856\" data-name=\"Rectangle 856\" width=\"60\" height=\"60\" transform=\"translate(1480)\" fill=\"#630106\" />\n    <g id=\"icon-search-red_Group_4722\" data-name=\"Group 4722\" transform=\"translate(1123.129 181.323)\">\n      <circle id=\"icon-search-red_Ellipse_15\" data-name=\"Ellipse 15\" cx=\"9.583\" cy=\"9.583\" r=\"9.583\" transform=\"translate(374.87 -163.323)\" fill=\"none\" stroke=\"#fff\" stroke-miterlimit=\"10\" stroke-width=\"2\" />\n      <line id=\"icon-search-red_Line_1\" data-name=\"Line 1\" x2=\"8.036\" y2=\"8.036\" transform=\"translate(391.229 -146.965)\" fill=\"none\" stroke=\"#fff\" stroke-miterlimit=\"10\" stroke-width=\"2\" />\n    </g>\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/search-red.svg
// module id = 9Arq
// module chunks = 3